import { Time } from '@internationalized/date';
import { RemoteData } from '@passionware/monads';
import { Production } from '__types__';
import { CallsheetDateSelection } from '../types';
import { myServices } from '../../../services/services.connected.app';

export interface UseProductionResourceCountsProps {
  /** Productions record from useProductionsById */
  productionsRecord: Record<number, RemoteData<Production>>;
  /** Date selection (single or range) */
  dateSelection: CallsheetDateSelection;
  /** General call time */
  generalCallTime: Time | null;
}

export type ProductionResourceCount = Record<number, RemoteData<number | null>>;

/**
 * Hook to calculate resource counts per production for the selected date(s).
 * Handles both single date and date range modes.
 * Returns individual RemoteData per production.
 */
export function useProductionResourceCounts({
  productionsRecord,
  dateSelection,
  generalCallTime
}: UseProductionResourceCountsProps): ProductionResourceCount {
  const isRangeMode = dateSelection.type === 'range';

  const singleDate =
    dateSelection.type === 'single' ? dateSelection.date : dateSelection.from;
  const rangeDates =
    dateSelection.type === 'range'
      ? { from: dateSelection.from, to: dateSelection.to }
      : { from: singleDate, to: singleDate };

  const generatedDataSingle =
    myServices.callsheetService.useGeneratedCallsheetCountsByProduction(
      productionsRecord,
      {
        selectedDate: singleDate,
        callTime: generalCallTime
      }
    );

  const generatedDataRange =
    myServices.callsheetService.useGeneratedCallsheetCountsByProductionForRange(
      productionsRecord,
      {
        dateRange: rangeDates,
        callTime: generalCallTime
      }
    );

  return isRangeMode ? generatedDataRange : generatedDataSingle;
}
